import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
import { Employee } from "src/app/model/employee";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
}

export class AcceptIdeaCommitteeInput {
  id: Scalars["String"];
}

export class AcceptIdeaInput {
  committee: AcceptIdeaCommitteeInput;
  id: Scalars["String"];
  tags: Array<Scalars["String"]>;
}

export class Action {
  code: Scalars["String"];
  comments?: Maybe<Array<ActionComment>>;
  createdAt: Scalars["DateTime"];
  description: Scalars["String"];
  endDate: Scalars["DateTime"];
  files?: Maybe<Array<ActionFile>>;
  history?: Maybe<Array<ActionHistory>>;
  id: Scalars["ID"];
  idea?: Maybe<Idea>;
  responsible?: Maybe<User>;
  startDate: Scalars["DateTime"];
  status: Scalars["String"];
  tasks?: Maybe<Array<ActionTask>>;
  title: Scalars["String"];
  updatedAt: Scalars["DateTime"];
}

export class ActionComment {
  action?: Maybe<Action>;
  comment: Scalars["String"];
  createdAt: Scalars["DateTime"];
  id: Scalars["String"];
  user?: Maybe<User>;
}

export class ActionFile {
  action?: Maybe<Action>;
  id: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
}

export class ActionHistory {
  action?: Maybe<Action>;
  after?: Maybe<Scalars["String"]>;
  before?: Maybe<Scalars["String"]>;
  changedData: Scalars["String"];
  createdAt: Scalars["DateTime"];
  id: Scalars["String"];
  type: Scalars["String"];
  user?: Maybe<User>;
}

export class ActionHistoryPage {
  currentPage: Scalars["Int"];
  history: Array<ActionHistory>;
  nextPage: Scalars["Boolean"];
  pageSize: Scalars["Int"];
  previouPage: Scalars["Boolean"];
  totalCount: Scalars["Int"];
  totalPage: Scalars["Int"];
}

export class ActionKamban {
  action: Action;
  commentsCount: Scalars["Int"];
  doneTasks: Scalars["Int"];
  filesCount: Scalars["Int"];
  isDelayed: Scalars["Boolean"];
  totalTasks: Scalars["Int"];
}

export class ActionTask {
  action?: Maybe<Action>;
  createdAt: Scalars["DateTime"];
  description: Scalars["String"];
  id: Scalars["String"];
  status: Scalars["Boolean"];
}

export class ApproveIdeaExpectationsInput {
  /** Enum: "finance-admin", "productive-admin", "sustainability-admin" */
  expectation: Scalars["String"];
  expectationDescription: Scalars["String"];
}

export class ApproveIdeaInput {
  analysisDescription?: InputMaybe<Scalars["String"]>;
  /** decimal(10,2) */
  analysisFinacialreturn?: InputMaybe<Scalars["Float"]>;
  /** decimal(10,2) */
  analysisMachineValue?: InputMaybe<Scalars["Float"]>;
  /** decimal(10,2) */
  analysisManValue?: InputMaybe<Scalars["Float"]>;
  /** enum water|energy|waste */
  analysisSustainability?: InputMaybe<Scalars["String"]>;
  expectations?: InputMaybe<Array<ApproveIdeaExpectationsInput>>;
  id: Scalars["ID"];
  implementationResume: Scalars["String"];
  premiationDate: Scalars["DateTime"];
  sustainability?: InputMaybe<Array<ApproveIdeaSustainabilityInput>>;
}

export class ApproveIdeaSustainabilityInput {
  id: Scalars["String"];
}

export class Area {
  committee?: Maybe<Array<Committee>>;
  id: Scalars["ID"];
  name: Scalars["String"];
}

export class AuthInput {
  application: Scalars["String"];
  code: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  redirectUri: Scalars["String"];
  access_token: Scalars["String"];
}

export class AuthType {
  country: Scalars["String"];
  token: Scalars["String"];
  user: User;
  kaizen: Scalars["Boolean"];
  access_token: Scalars["String"];
}

export class BaseInput {
  id: Scalars["String"];
}

/** Entity Challenge Object */
export class Challenge {
  id: Scalars["ID"];
  type: Scalars["String"];
  name: Scalars["String"];
  title: Scalars["String"];
  status: Scalars["String"];
  language: Scalars["String"];
  description: Scalars["String"];
  isDateSensitive?: Maybe<Scalars["Boolean"]>;

  startDate?: Maybe<Scalars["DateTime"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  deletedAt?: Maybe<Scalars["DateTime"]>;
}

export class Committee {
  area?: Maybe<Area>;
  createdAt: Scalars["DateTime"];
  deletedAt?: Maybe<Scalars["DateTime"]>;
  id: Scalars["ID"];
  idea?: Maybe<Array<Idea>>;
  manager?: Maybe<User>;
  name: Scalars["String"];
  participants?: Maybe<Array<User>>;
  status: Scalars["Boolean"];
  unity?: Maybe<Unity>;
}

export class Country {
  flag: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  unity: Array<Unity>;
}

export class CreateActionCommentActionInput {
  id: Scalars["String"];
}

export class CreateActionCommentInput {
  action: CreateActionCommentActionInput;
  comment: Scalars["String"];
}

export class CreateActionIdeaInput {
  id: Scalars["String"];
}

export class CreateActionInput {
  description: Scalars["String"];
  endDate: Scalars["DateTime"];
  idea: CreateActionIdeaInput;
  responsible: CreateActionResponsibleInput;
  startDate: Scalars["DateTime"];
  /** Enum pending|in progress|done|canceled */
  status: Scalars["String"];
  title: Scalars["String"];
}

export class CreateActionResponsibleInput {
  id: Scalars["String"];
}

export class CreateActionTaskActionInput {
  id: Scalars["String"];
}

export class CreateActionTaskInput {
  action: CreateActionTaskActionInput;
  description: Scalars["String"];
}

export class CreateAreaInput {
  name: Scalars["String"];
}

/** Object create new challenge */
export class CreateChallengeInput {
  description: Scalars["String"];
  endDate?: InputMaybe<Scalars["DateTime"]>;
  isDateSensitive: Scalars["Boolean"];
  language: Scalars["String"];
  name: Scalars["String"];
  startDate?: InputMaybe<Scalars["DateTime"]>;
  status: Scalars["String"];
  title: Scalars["String"];
}

export class CreateCommitteeAreaInput {
  id: Scalars["String"];
}

export class CreateCommitteeInput {
  area?: InputMaybe<CreateCommitteeAreaInput>;
  manager: CreateCommitteeManagerInput;
  name: Scalars["String"];
  participants: Array<CreateCommitteeParticipantInput>;
  status: Scalars["Boolean"];
  unity: CreateCommitteeUnityInput;
}

export class CreateCommitteeManagerInput {
  id: Scalars["String"];
}

export class CreateCommitteeParticipantInput {
  id: Scalars["String"];
}

export class CreateCommitteeUnityInput {
  id: Scalars["String"];
}

export class CreateCountryInput {
  flag: Scalars["String"];
  name: Scalars["String"];
}

export class CreateIdeaAuthorInput {
  area?: InputMaybe<Scalars["String"]>;
  costCenter?: InputMaybe<Scalars["String"]>;
  cpf?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  jobRole?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  re: Scalars["String"];
}

export type ChallengeType = "standard" | "personalized";

export class CreateIdeaChallenge {
  id: Scalars["String"];
  type: ChallengeType;
  language: Scalars["String"];
}

export class CreateIdeaCommentInput {
  message: Scalars["String"];
  name: Scalars["String"];
}

export class CreateIdeaConclusionIdeaInput {
  id: Scalars["String"];
}

export class CreateIdeaConclusionInput {
  /** enum not attend|parctially attends|attend|overcomes */
  financialVote: Scalars["String"];
  financialVoteDescription?: InputMaybe<Scalars["String"]>;
  idea: CreateIdeaConclusionIdeaInput;
  /** decimal(10,2) */
  prize: Scalars["Float"];
  /** enum not attend|parctially attends|attend|overcomes */
  productivityVote: Scalars["String"];
  productivityVoteDescription?: InputMaybe<Scalars["String"]>;
  /** enum not attend|parctially attends|attend|overcomes */
  sustainabilityVote: Scalars["String"];
  sustainabilityVoteDescription?: InputMaybe<Scalars["String"]>;
}

export class CreateIdeaCountryInput {
  id: Scalars["String"];
}

export class CreateIdeaExpectationInput {
  challengeLanguage?: InputMaybe<Scalars["String"]>;
  expectation: Scalars["String"];
  expectationDescription: Scalars["String"];
}

export class CreateIdeaKaizenAreaInput {
  area: Scalars["String"];
}

export class CreateIdeaChallengeInput {
  title: Scalars["String"];
  re: Scalars["String"];
  role: Scalars["String"];
  email: Scalars["String"];
  unity: CreateIdeaUnityInput;
  currentProblem: Scalars["String"];
  problemSolution: Scalars["String"];
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge: CreateIdeaChallenge;
  phone: Scalars["String"];
}

export class CreateIdeaInput {
  areaExtensionLine: Scalars["String"];
  areaResponsible: Scalars["String"];
  authorName: Scalars["String"];
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge: CreateIdeaChallenge;
  contactHour: Scalars["String"];
  costCenter: Scalars["String"];
  country: CreateIdeaCountryInput;
  description: Scalars["String"];
  document: Scalars["String"];
  email: Scalars["String"];
  expectation?: InputMaybe<Array<CreateIdeaExpectationInput>>;
  managerName: Scalars["String"];
  phone: Scalars["String"];
  phoneExtensionLine: Scalars["String"];
  productiveDescription?: InputMaybe<Scalars["String"]>;
  productiveEquipament?: Scalars["Boolean"];
  re: Scalars["String"];
  role: Scalars["String"];
  title: Scalars["String"];
  turn: Scalars["String"];
  unity: CreateIdeaUnityInput;
  currentProblem: Scalars["String"];
  problemSolution: Scalars["String"];
}
export class CreateIdeaKaizenInput {
  areaExtensionLine?: Scalars["String"];
  areaResponsible?: Scalars["String"];
  authorName?: Scalars["String"];
  authors?: InputMaybe<CreateIdeaAuthorInput[]>;
  challenge?: CreateIdeaChallenge;
  contactHour?: Scalars["String"];
  costCenter?: Scalars["String"];
  country?: CreateIdeaCountryInput;
  description?: Scalars["String"] | null;
  bucketRequestId?: Scalars["String"];
  points?: Scalars["Int"];
  document?: Scalars["String"];
  email?: Scalars["String"];
  frame: Scalars["String"];
  area: Scalars["String"];
  expectation?: InputMaybe<CreateIdeaExpectationInput[]>;
  managerName?: Scalars["String"];
  phone?: Scalars["String"];
  phoneExtensionLine?: Scalars["String"];
  productiveDescription?: InputMaybe<Scalars["String"]>;
  productiveEquipament?: Scalars["Boolean"];
  re: Scalars["String"];
  role?: Scalars["String"];
  title: Scalars["String"];
  turn?: Scalars["String"];
  unity?: CreateIdeaUnityInput;
  userId?: InputMaybe<Scalars["String"]>;
  employeeId?: InputMaybe<Scalars["String"]>;
  problem?: Scalars["String"];
  solution?: Scalars["String"];
  initialDate?: Scalars["DateTime"];
  otherAuthors?: Scalars["String"];
}

export class CreateIdeaUnityInput {
  id: Scalars["String"];
}

export class CreateNewsInput {
  author: Scalars["String"];
  content: Scalars["String"];
  description: Scalars["String"];
  /** Enum "published"|"unpublished" */
  status: Scalars["String"];
  tag?: InputMaybe<Array<Scalars["String"]>>;
  title: Scalars["String"];
}

export class CreateNotificationInput {
  date: Scalars["DateTime"];
  email?: InputMaybe<Scalars["String"]>;
  message: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  relationId: Scalars["String"];
  subject?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
  type: Scalars["String"];
  user?: InputMaybe<NotificationUserInput>;
  userId?: Scalars["String"];
}

export class CreateTagInput {
  tag: Scalars["String"];
}

export class CreateUnityCountryInput {
  id: Scalars["String"];
}

export class CreateUnityInput {
  country: CreateUnityCountryInput;
  name: Scalars["String"];
}

export class CreateUserCommitteeInput {
  id: Scalars["String"];
}

export class CreateUserInput {
  email: Scalars["String"];
  name: Scalars["String"];
  role: Scalars["String"];
  unity?: InputMaybe<CreateUserUnityInput>;
}

export class CreateUserUnityInput {
  id: Scalars["String"];
}

export class DashboardHome {
  approves: Scalars["Int"];
  energy: Scalars["Float"];
  finances: Scalars["Float"];
  machineValue: Scalars["Float"];
  manValue: Scalars["Float"];
  news: Scalars["Int"];
  waste: Scalars["Float"];
  water: Scalars["Float"];
}

export class DefaultMessage {
  message: Scalars["String"];
  status: Scalars["Int"];
}

export class Home {
  currentPage: Scalars["Int"];
  ideas: Array<Idea>;
  nextPage: Scalars["Boolean"];
  pageSize: Scalars["Int"];
  previouPage: Scalars["Boolean"];
  tasksCanceled: Scalars["Int"];
  tasksDone: Scalars["Int"];
  tasksInProgress: Scalars["Int"];
  tasksPending: Scalars["Int"];
  totalCount: Scalars["Int"];
  totalPage: Scalars["Int"];
}

/** Entity Idea Object */
export class Idea {
  action?: Maybe<Array<Action>>;
  analysisDescription?: Maybe<Scalars["String"]>;
  analysisFinacialreturn: Scalars["Float"];
  analysisMachineValue: Scalars["Float"];
  analysisManValue: Scalars["Float"];
  analysisSustainability?: Maybe<Scalars["String"]>;
  areaExtensionLine?: Maybe<Scalars["String"]>;
  areaResponsible?: Maybe<Scalars["String"]>;
  authorName: Scalars["String"];
  authors?: Maybe<Array<IdeaAuthor>>;
  blocked?: Maybe<Scalars["Boolean"]>;
  challenge?: Maybe<Challenge>;
  challengeLanguage?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  comments?: Maybe<Array<IdeaComment>>;
  committee?: Maybe<Committee>;
  conclusion?: Maybe<IdeaConclusion>;
  contactHour?: Maybe<Scalars["String"]>;
  costCenter?: Maybe<Scalars["String"]>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  deletedAt?: Maybe<Scalars["DateTime"]>;
  description?: Maybe<Scalars["String"]>;
  document: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  endedAction?: Maybe<Scalars["Int"]>;
  expectations?: Maybe<Array<IdeaExpectation>>;
  father?: Maybe<Idea>;
  financeValue: Scalars["Float"];
  id: Scalars["ID"];
  ideafiles?: Maybe<Array<IdeaFile>>;
  implementationResume?: Maybe<Scalars["String"]>;
  keyWords?: Maybe<Scalars["String"]>;
  likes: Scalars["Float"];
  managerName?: Maybe<Scalars["String"]>;
  motive?: Maybe<Scalars["String"]>;
  nameCode?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  phoneExtensionLine?: Maybe<Scalars["String"]>;
  premiationDate?: Maybe<Scalars["DateTime"]>;
  productiveDescription?: Maybe<Scalars["String"]>;
  productiveEquipament?: Scalars["Boolean"];
  productivityValueHH: Scalars["Float"];
  productivityValueHM: Scalars["Float"];
  re: Scalars["String"];
  resumeIdea?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  short?: Maybe<Scalars["String"]>;
  sons?: Maybe<Array<Idea>>;
  /** Enum received|approved|approved_awatd|denied|denial|awarded|analysis */
  status: Scalars["String"];
  statusOrder?: Maybe<Scalars["Float"]>;
  /** Enum received|denied|awarded|analysis */
  statusUser: Scalars["String"];
  sustainability?: Maybe<Array<Sustainability>>;
  sustentabilityPoint: Scalars["Float"];
  sustentabilityType?: Maybe<Scalars["String"]>;
  tags?: Maybe<Array<IdeaTag>>;
  title: Scalars["String"];
  turn?: Maybe<Scalars["String"]>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars["DateTime"];
}

/** Entity Idea Author Object */
export class IdeaAuthor {
  area?: Maybe<Scalars["String"]>;
  costCenter?: Maybe<Scalars["String"]>;
  cpf?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  idea: Idea;
  jobRole?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  re: Scalars["String"];
}

/** Entity Idea Comment Object */
export class IdeaComment {
  createdAt: Scalars["DateTime"];
  deletedAt: Scalars["DateTime"];
  id: Scalars["ID"];
  message: Scalars["String"];
  name: Scalars["String"];
  /** Enum approved|denied|pending */
  status: Scalars["String"];
}

export class IdeaConclusion {
  createdAt: Scalars["DateTime"];
  financialVote: Scalars["String"];
  financialVoteDescription?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  idea: Idea;
  prize: Scalars["Float"];
  productivityVote: Scalars["String"];
  productivityVoteDescription?: Maybe<Scalars["String"]>;
  sustainabilityVote: Scalars["String"];
  sustainabilityVoteDescription?: Maybe<Scalars["String"]>;
}

/** Entity Idea Author Object */
export class IdeaExpectation {
  challengeLanguage?: Maybe<Scalars["String"]>;
  /** Enum finance|productive|sustainability */
  expectation: Scalars["String"];
  expectationDescription: Scalars["String"];
  id: Scalars["ID"];
  idea: Idea;
  isSelected: Scalars["Boolean"];
}

export class IdeaArea {
  challengeLanguage?: Maybe<Scalars["String"]>;
  /** Enum qualidade|segurança|produção|manutenção|outros */
  area: Scalars["String"];
  // id: Scalars['ID'];
  // idea: Idea;
  isSelected: Scalars["Boolean"];
}

export class IdeaKaizen {
  areaExtensionLine?: Scalars["String"];
  areaResponsible?: Scalars["String"];
  authorName?: Scalars["String"];
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge?: CreateIdeaChallengeInput;
  contactHour?: Scalars["String"];
  costCenter?: Scalars["String"];
  country?: CreateIdeaCountryInput;
  description?: Scalars["String"] | null;
  image: Scalars["String"];
  points?: Scalars["Int"];
  document?: Scalars["String"];
  email?: Scalars["String"];
  frame: Scalars["String"];
  area: Scalars["String"];
  expectation?: InputMaybe<Array<CreateIdeaExpectationInput>>;
  managerName?: Scalars["String"];
  phone?: Scalars["String"];
  phoneExtensionLine?: Scalars["String"];
  productiveDescription?: InputMaybe<Scalars["String"]>;
  productiveEquipament?: Scalars["Boolean"];
  re: Scalars["String"];
  role?: Scalars["String"];
  title: Scalars["String"];
  turn?: Scalars["String"];
  unity?: CreateIdeaUnityInput;
  userId: Scalars["String"];
  code: Scalars["String"];
  status: Scalars["String"];
  createdAt: Scalars["String"];

  comments: Scalars["String"];
  motive: Scalars["String"];
  likes: Scalars["Int"];

  expectations: any;
}

export class IdeaFile {
  file?: Maybe<Scalars["String"]>;
  fileName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  idea?: Maybe<Idea>;
}

export class IdeaPage {
  currentPage: Scalars["Int"];
  ideas: Array<Idea>;
  nextPage: Scalars["Boolean"];
  pageSize: Scalars["Int"];
  previouPage: Scalars["Boolean"];
  totalCount: Scalars["Int"];
  totalPage: Scalars["Int"];
}

export class IdeaTag {
  id: Scalars["String"];
  idea: Idea;
  tag: Scalars["String"];
}

export class Kamban {
  cards?: Maybe<Array<ActionKamban>>;
  name: Scalars["String"];
}

export class Mutation {
  acceptIdea: Idea;
  /** Add one like to an idea */
  addLike: Scalars["Float"];
  /** Add tags to News */
  addNewsTags: News;
  approvedIdea: Idea;
  awardIdea: Idea;
  createAction: Action;
  createActionComment: ActionComment;
  createActionTask: ActionTask;
  createArea: Area;
  /** Create a new Challenge */
  createChallenge: Challenge;
  createCommittee: Committee;
  /** Create a new Country */
  createCountry: Country;
  /** Create a new Idea */
  createIdea: Idea;
  /** Create a new Comment in Idea */
  createIdeaComment: IdeaComment;
  createIdeaConclusion: IdeaConclusion;
  /** Create new news */
  createNews: News;
  createNotification: Notification;
  /** Create new tag */
  createTag: NewsTag;
  /** Create a new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  denyIdea: Idea;
  login: AuthType;
  readNotification: Notification;
  removeAction: DefaultMessage;
  removeActionFile: DefaultMessage;
  removeActionTask: DefaultMessage;
  removeArea: DefaultMessage;
  /** Remove a Challenge By ID */
  removeChallenge: DefaultMessage;
  removeCommittee: DefaultMessage;
  /** Remove Country By ID */
  removeCountry: Country;
  removeFile: DefaultMessage;
  /** Remove a Idea by ID */
  removeIdea: Idea;
  /** Remove news by id */
  removeNews: DefaultMessage;
  removeNotification: DefaultMessage;
  /** Remove tag by id */
  removeTag: Scalars["Boolean"];
  /** Remove Unity */
  removeUnity: DefaultMessage;
  /** Remove a user by ID */
  removeUser: Scalars["Boolean"];
  reproveIdea: Idea;
  translateIdea: DefaultMessage;
  updateAction: Action;
  updateActionComment: ActionComment;
  updateActionStatus: Action;
  updateActionTaskStatus: ActionTask;
  updateArea: Area;
  /** Update a Challenge */
  updateChallenge: Challenge;
  updateCommittee: Committee;
  /** Update a Idea */
  updateIdea: Idea;
  updateIdeaCommittee: DefaultMessage;
  updateIdeaConclusion: IdeaConclusion;
  updateIdeaImplementation: Idea;
  /** Update news by id */
  updateNews: News;
  updateNotification: Notification;
  /** Update tag by id */
  updateTag: NewsTag;
  /** Update Unity */
  updateUnity: Unity;
  /** Update a User By ID */
  updateUser: User;
}

export class MutationAcceptIdeaArgs {
  data: AcceptIdeaInput;
}

export class MutationAddLikeArgs {
  id: Scalars["String"];
}

export class MutationAddNewsTagsArgs {
  id: Scalars["ID"];
  tag: Array<Scalars["String"]>;
}

export class MutationApprovedIdeaArgs {
  data: ApproveIdeaInput;
}

export class MutationAwardIdeaArgs {
  id: Scalars["String"];
}

export class MutationCreateActionArgs {
  data: CreateActionInput;
}

export class MutationCreateActionCommentArgs {
  data: CreateActionCommentInput;
}

export class MutationCreateActionTaskArgs {
  data: CreateActionTaskInput;
}

export class MutationCreateAreaArgs {
  data: CreateAreaInput;
}

export class MutationCreateChallengeArgs {
  data: CreateChallengeInput;
}

export class MutationCreateCommitteeArgs {
  createCommitteeInput: CreateCommitteeInput;
}

export class MutationCreateCountryArgs {
  data: CreateCountryInput;
}

export class MutationCreateIdeaArgs {
  data: CreateIdeaInput;
}

export class MutationCreateIdeaCommentArgs {
  data: CreateIdeaCommentInput;
  id: Scalars["String"];
}

export class MutationCreateIdeaConclusionArgs {
  data: CreateIdeaConclusionInput;
}

export class MutationCreateNewsArgs {
  data: CreateNewsInput;
}

export class MutationCreateNotificationArgs {
  data: CreateNotificationInput;
}

export class MutationCreateTagArgs {
  data: CreateTagInput;
}

export class MutationCreateUnityArgs {
  data: CreateUnityInput;
}

export class MutationCreateUserArgs {
  data: CreateUserInput;
}

export class MutationDenyIdeaArgs {
  id: Scalars["String"];
}

export class MutationLoginArgs {
  data: AuthInput;
}

export class MutationReadNotificationArgs {
  id: Scalars["String"];
}

export class MutationRemoveActionArgs {
  id: Scalars["ID"];
}

export class MutationRemoveActionFileArgs {
  id: Scalars["ID"];
}

export class MutationRemoveActionTaskArgs {
  id: Scalars["ID"];
}

export class MutationRemoveAreaArgs {
  id: Scalars["ID"];
}

export class MutationRemoveChallengeArgs {
  id: Scalars["String"];
  language: Scalars["String"];
}

export class MutationRemoveCommitteeArgs {
  id: Scalars["ID"];
}

export class MutationRemoveCountryArgs {
  id: Scalars["String"];
}

export class MutationRemoveFileArgs {
  id: Scalars["String"];
}

export class MutationRemoveIdeaArgs {
  id: Scalars["Int"];
}

export class MutationRemoveNewsArgs {
  id: Scalars["String"];
}

export class MutationRemoveNotificationArgs {
  id: Scalars["String"];
}

export class MutationRemoveTagArgs {
  id: Scalars["ID"];
}

export class MutationRemoveUnityArgs {
  id: Scalars["String"];
}

export class MutationRemoveUserArgs {
  id: Scalars["String"];
}

export class MutationReproveIdeaArgs {
  data: ReproveIdeaInput;
}

export class MutationTranslateIdeaArgs {
  data: Array<TranslateIdeaInput>;
}

export class MutationUpdateActionArgs {
  data: UpdateActionInput;
}

export class MutationUpdateActionCommentArgs {
  data: UpdateActionCommentInput;
}

export class MutationUpdateActionStatusArgs {
  id: Scalars["ID"];
  status: Scalars["String"];
}

export class MutationUpdateActionTaskStatusArgs {
  id: Scalars["ID"];
}

export class MutationUpdateAreaArgs {
  data: UpdateAreaInput;
}

export class MutationUpdateChallengeArgs {
  data: UpdateChallengeInput;
  language: Scalars["String"];
}

export class MutationUpdateCommitteeArgs {
  data: UpdateCommitteeInput;
}

export class MutationUpdateIdeaArgs {
  data: UpdateIdeaInput;
}

export class MutationUpdateIdeaCommitteeArgs {
  data: UpdateIdeaCommitteeInput;
}

export class MutationUpdateIdeaConclusionArgs {
  data: UpdateIdeaConclusionInput;
}

export class MutationUpdateIdeaImplementationArgs {
  data: UpdateIdeaImplementationInput;
}

export class MutationUpdateNewsArgs {
  data: UpdateNewsInput;
}

export class MutationUpdateNotificationArgs {
  data: UpdateNotificationInput;
}

export class MutationUpdateTagArgs {
  data: UpdateTagInput;
}

export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
}

export class MutationUpdateUserArgs {
  data: UpdateUserInput;
  id: Scalars["String"];
}

/** Entity News Object */
export class News {
  author: Scalars["String"];
  content: Scalars["String"];
  createdAt: Scalars["DateTime"];
  description: Scalars["String"];
  id: Scalars["ID"];
  imageUrl?: Maybe<Scalars["String"]>;
  language: Scalars["String"];
  status: Scalars["String"];
  tags?: Maybe<Array<NewsTag>>;
  title: Scalars["String"];
  updatedAt: Scalars["DateTime"];
}

export class NewsPage {
  currentPage: Scalars["Int"];
  news: Array<News>;
  nextPage: Scalars["Boolean"];
  pageSize: Scalars["Int"];
  previouPage: Scalars["Boolean"];
  totalCount: Scalars["Int"];
  totalPage: Scalars["Int"];
}

/** Entity Tags Object */
export class NewsTag {
  id: Scalars["ID"];
  news: News;
  tag: Scalars["String"];
}

export class Notification {
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  isRead: Scalars["Boolean"];
  message: Scalars["String"];
  relationId?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  type: Scalars["String"];
  user?: Maybe<User>;
}

export class NotificationUserInput {
  id: Scalars["String"];
}

export class PageChallenge {
  currentPage: Scalars["Int"];
  nextPage: Scalars["Boolean"];
  pageSize: Scalars["Int"];
  previouPage: Scalars["Boolean"];
  results: Array<Challenge>;
  totalCount: Scalars["Int"];
  totalPage: Scalars["Int"];
}

export class Query {
  /** Return All Unities by user role */
  UnitiesByUser: Array<Unity>;
  action: Action;
  actionHistory: ActionHistoryPage;
  actionKamban: Array<Kamban>;
  actionStatus: Array<Scalars["String"]>;
  actions: Array<Action>;
  area: Area;
  areas: Array<Area>;
  codes: Array<Scalars["String"]>;
  committee: Committee;
  committees: Array<Committee>;
  /** Return All Ideas By Keyword */
  getAllIdeas: Array<Idea>;
  /** Find a Challenge By ID */
  getChallenge: Challenge;
  /** Return all Challenges */
  getChallenges: Array<Challenge>;
  /** Return all Challenges of set language */
  getChallengesByLanguage: Array<Challenge>;
  /** Return all Challenges of set language */
  getChallengesByLanguageAll: Array<Challenge>;
  /** Return All Countries */
  getCountries: Array<Country>;
  /** Get Country By ID */
  getCountry: Country;
  /** Return Dashboard Home */
  getDashboardHome: DashboardHome;
  /** Return Idea by ID */
  getIdea: Idea;
  /** Return All Ideas */
  getIdeas: Array<Idea>;
  /** Return All Ideas By Keyword */
  getIdeasSearch: Array<Idea>;
  /** Return news by id */
  getNew: News;
  /** List all news */
  getNews: Array<News>;
  /** List all news by Keyword */
  getNewsSearch: NewsPage;
  /** Return tag by id */
  getTag: NewsTag;
  /** List all tags */
  getTags: Array<NewsTag>;
  /** Return All Unities */
  getUnities: Array<Unity>;
  /** Return All Unities By CountryId */
  getUnitiesByCountry: Array<Unity>;
  /** Get Unity By ID */
  getUnity: Unity;
  /** Return a User by ID */
  getUser: User;
  /** Return a User by Email */
  getUserByEmail: User;
  /** Return All Users */
  getUsers: Array<User>;
  home: Home;
  ideaByStatus: Array<Idea>;
  /** Current User */
  me: User;
  notification: Notification;
  notifications: Array<Notification>;
  notificationsByUser: UserNotificationDto;
  pageChallenges: PageChallenge;
  searchAction: Array<Kamban>;
  /** Search for admin */
  searchAllIdeas: IdeaPage;
  searchArea: Array<Area>;
  searchCommittee: Array<Committee>;
  searchUnity: Array<Unity>;
  searchUser: Array<User>;
  sustainabilities: Array<Sustainability>;
  validateApproveIdea: DefaultMessage;
}

export class QueryActionArgs {
  id: Scalars["ID"];
}

export class QueryActionHistoryArgs {
  id: Scalars["String"];
  page?: InputMaybe<Scalars["Float"]>;
}

export class QueryActionKambanArgs {
  id: Scalars["ID"];
}

export class QueryAreaArgs {
  id: Scalars["ID"];
}

export class QueryCommitteeArgs {
  id: Scalars["ID"];
}

export class QueryGetAllIdeasArgs {
  keyword?: InputMaybe<Scalars["String"]>;
}

export class QueryGetChallengeArgs {
  id: Scalars["String"];
  language: Scalars["String"];
}

export class QueryGetChallengesByLanguageArgs {
  language: Scalars["String"];
}

export class QueryGetChallengesByLanguageAllArgs {
  language: Scalars["String"];
}

export class QueryGetCountryArgs {
  id: Scalars["String"];
}

export class QueryGetIdeaArgs {
  id: Scalars["String"];
}

export class QueryGetIdeasSearchArgs {
  data: SearchIdeaInput;
}

export class QueryGetNewArgs {
  id: Scalars["String"];
  language?: InputMaybe<Scalars["String"]>;
}

export class QueryGetNewsSearchArgs {
  keyword: Scalars["String"];
  language?: InputMaybe<Scalars["String"]>;
  page?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<Scalars["String"]>;
}

export class QueryGetTagArgs {
  id: Scalars["ID"];
}

export class QueryGetUnitiesByCountryArgs {
  id: Scalars["String"];
}

export class QueryGetUnityArgs {
  id: Scalars["String"];
}

export class QueryGetUserArgs {
  id: Scalars["String"];
}

export class QueryGetUserByEmailArgs {
  email: Scalars["String"];
}

export class QueryHomeArgs {
  page?: InputMaybe<Scalars["Float"]>;
}

export class QueryIdeaByStatusArgs {
  status: Array<Scalars["String"]>;
}

export class QueryNotificationArgs {
  id: Scalars["String"];
}

export class QueryPageChallengesArgs {
  filter: SearchChallengeInput;
}

export class QuerySearchActionArgs {
  data: SearchActionInput;
}

export class QuerySearchAllIdeasArgs {
  data: SearchIdeaInput;
}

export class QuerySearchAreaArgs {
  data: SearchAreaInput;
}

export class QuerySearchCommitteeArgs {
  data: SearchCommittee;
}

export class QuerySearchUnityArgs {
  data: SearchUnityInput;
}

export class QuerySearchUserArgs {
  data: SearchUserInput;
}

export class QueryValidateApproveIdeaArgs {
  id: Scalars["String"];
}

export class ReproveIdeaInput {
  id: Scalars["ID"];
  motive: Scalars["String"];
}

export class SearchActionInput {
  committee?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  idea?: InputMaybe<Scalars["String"]>;
  isDelayed?: InputMaybe<Scalars["Boolean"]>;
  keyword?: InputMaybe<Scalars["String"]>;
  responsible?: InputMaybe<Array<Scalars["String"]>>;
  start?: InputMaybe<Scalars["DateTime"]>;
  unity?: InputMaybe<Scalars["String"]>;
}

export class SearchAreaInput {
  keyword?: InputMaybe<Scalars["String"]>;
}

export class SearchChallengeInput {
  keyword?: InputMaybe<Scalars["String"]>;
  /** enum "pt-BR"|"es-ES" */
  language?: InputMaybe<Scalars["String"]>;
  page?: InputMaybe<Scalars["Int"]>;
}

export class SearchCommittee {
  area?: InputMaybe<Scalars["String"]>;
  keyword?: InputMaybe<Scalars["String"]>;
  manager?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["Boolean"]>;
  unity?: InputMaybe<Scalars["String"]>;
}

export class SearchIdeaInput {
  committeeId?: InputMaybe<Array<Scalars["String"]>>;
  countryId?: InputMaybe<Scalars["String"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
  keyword?: InputMaybe<Scalars["String"]>;
  /** Enum name|createdAt */
  order?: InputMaybe<Scalars["String"]>;
  page?: InputMaybe<Scalars["Int"]>;
  responsibleId?: InputMaybe<Scalars["String"]>;
  start?: InputMaybe<Scalars["DateTime"]>;
  status?: InputMaybe<Array<Scalars["String"]>>;
  unityId?: InputMaybe<Scalars["String"]>;
}

export class SearchUnityInput {
  country?: InputMaybe<Scalars["String"]>;
  keyword?: InputMaybe<Scalars["String"]>;
}

export class SearchUserInput {
  committee?: InputMaybe<Scalars["String"]>;
  keyword?: InputMaybe<Scalars["String"]>;
}

export class Sustainability {
  id: Scalars["ID"];
  idea?: Maybe<Idea>;
  type?: Maybe<Scalars["String"]>;
}

export class TranslateIdeaChallengeInput {
  id: Scalars["String"];
}

export class TranslateIdeaExpectationInput {
  expectation: Scalars["String"];
  expectationDescription: Scalars["String"];
  id: Scalars["String"];
}

export class TranslateIdeaInput {
  analysisDescription?: InputMaybe<Scalars["String"]>;
  challengeId: TranslateIdeaChallengeInput;
  /** Enum: 'pt-BR'|'es-ES' */
  challengeLanguage: Scalars["String"];
  description: Scalars["String"];
  expectation?: InputMaybe<Array<TranslateIdeaExpectationInput>>;
  id: Scalars["ID"];
  motive?: InputMaybe<Scalars["String"]>;
  productiveDescription?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
}

export class Unity {
  committee?: Maybe<Array<Committee>>;
  country?: Maybe<Country>;
  id: Scalars["ID"];
  idea?: Maybe<Array<Idea>>;
  name: Scalars["String"];
  user?: Maybe<Array<User>>;
}

export class UpdateActionCommentInput {
  comment: Scalars["String"];
  id: Scalars["ID"];
}

export class UpdateActionInput {
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["DateTime"]>;
  id: Scalars["ID"];
  idea?: InputMaybe<CreateActionIdeaInput>;
  responsible?: InputMaybe<CreateActionResponsibleInput>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
  /** Enum pending|in progress|done|canceled */
  status?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
}

export class UpdateAreaInput {
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
}

/** Object update challenge */
export class UpdateChallengeInput {
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["DateTime"]>;
  id: Scalars["String"];
  isDateSensitive?: InputMaybe<Scalars["Boolean"]>;
  language?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
  status?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
}

export class UpdateCommitteeInput {
  area?: InputMaybe<CreateCommitteeAreaInput>;
  id?: InputMaybe<Scalars["ID"]>;
  manager?: InputMaybe<CreateCommitteeManagerInput>;
  name?: InputMaybe<Scalars["String"]>;
  participant?: InputMaybe<Array<CreateCommitteeParticipantInput>>;
  status?: InputMaybe<Scalars["Boolean"]>;
  unity?: InputMaybe<CreateCommitteeUnityInput>;
}

export class UpdateIdeaCommitteeInput {
  committe: BaseInput;
  id: Scalars["String"];
}

export class UpdateIdeaConclusionInput {
  /** enum not attend|parctially attends|attend|overcomes */
  financialVote?: InputMaybe<Scalars["String"]>;
  financialVoteDescription?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  idea?: InputMaybe<CreateIdeaConclusionIdeaInput>;
  /** decimal(10,2) */
  prize?: InputMaybe<Scalars["Float"]>;
  /** enum not attend|parctially attends|attend|overcomes */
  productivityVote?: InputMaybe<Scalars["String"]>;
  productivityVoteDescription?: InputMaybe<Scalars["String"]>;
  /** enum not attend|parctially attends|attend|overcomes */
  sustainabilityVote?: InputMaybe<Scalars["String"]>;
  sustainabilityVoteDescription?: InputMaybe<Scalars["String"]>;
}

export class UpdateIdeaImplementationInput {
  analysisDescription?: InputMaybe<Scalars["String"]>;
  /** decimal(10,2) */
  analysisFinacialreturn?: InputMaybe<Scalars["Float"]>;
  /** decimal(10,2) */
  analysisMachineValue?: InputMaybe<Scalars["Float"]>;
  /** decimal(10,2) */
  analysisManValue?: InputMaybe<Scalars["Float"]>;
  /** enum water|energy|waste */
  analysisSustainability?: InputMaybe<Scalars["String"]>;
  expectations?: InputMaybe<Array<ApproveIdeaExpectationsInput>>;
  id: Scalars["ID"];
  implementationResume: Scalars["String"];
  premiationDate: Scalars["DateTime"];
  sustainability?: InputMaybe<Array<ApproveIdeaSustainabilityInput>>;
}

export class UpdateIdeaInput {
  areaExtensionLine?: InputMaybe<Scalars["String"]>;
  areaResponsible?: InputMaybe<Scalars["String"]>;
  authorName?: InputMaybe<Scalars["String"]>;
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge?: InputMaybe<CreateIdeaChallengeInput>;
  contactHour?: InputMaybe<Scalars["String"]>;
  costCenter?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<CreateIdeaCountryInput>;
  description?: InputMaybe<Scalars["String"]>;
  document?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  expectation?: InputMaybe<Array<CreateIdeaExpectationInput>>;
  id: Scalars["String"];
  managerName?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  phoneExtensionLine?: InputMaybe<Scalars["String"]>;
  productiveDescription?: InputMaybe<Scalars["String"]>;
  productiveEquipament?: InputMaybe<Scalars["Boolean"]>;
  re?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  turn?: InputMaybe<Scalars["String"]>;
  unity?: InputMaybe<CreateIdeaUnityInput>;
}

export class UpdateNewsInput {
  author?: InputMaybe<Scalars["String"]>;
  content?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  id: Scalars["String"];
  /** Enum "published"|"unpublished" */
  status?: InputMaybe<Scalars["String"]>;
  tag?: InputMaybe<Array<Scalars["String"]>>;
  title?: InputMaybe<Scalars["String"]>;
}

export class UpdateNotificationInput {
  date?: InputMaybe<Scalars["DateTime"]>;
  email?: InputMaybe<Scalars["String"]>;
  id: Scalars["Int"];
  message?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  relationId?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  user?: InputMaybe<NotificationUserInput>;
}

export class UpdateTagInput {
  id: Scalars["String"];
  tag?: InputMaybe<Scalars["String"]>;
}

export class UpdateUnityInput {
  country?: InputMaybe<CreateUnityCountryInput>;
  id: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
}

export class UpdateUserInput {
  commites: Array<CreateUserCommitteeInput>;
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
  unity?: InputMaybe<UpdateUserUnityInput>;
  re?: InputMaybe<Scalars["String"]>;
}

export class UpdateUserUnityInput {
  id: Scalars["String"];
}

export class User {
  action?: Maybe<Array<Action>>;
  actionHistory?: Maybe<Array<ActionHistory>>;
  comments?: Maybe<Array<ActionComment>>;
  committeeManager?: Maybe<Array<Committee>>;
  committeeParticipants?: Maybe<Array<Committee>>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  email: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  notification?: Maybe<Array<Notification>>;
  photo?: Maybe<Scalars["String"]>;
  role: Scalars["String"];
  unity?: Maybe<Unity>;
  points?: Scalars["Int"];
  employee?: Maybe<Employee>;
}

export class UserNotificationDto {
  notifications: Array<Notification>;
  total: Scalars["Int"];
  unread: Scalars["Int"];
}

export type UserFragment = {
  id: string;
  name: string;
  email: string;
  photo?: string | null | undefined;
};

export type IdeaFragment = {
  id: string;
  status: string;
  title: string;
  code?: string | null | undefined;
  description?: string | null | undefined;
  authorName: string;
  role?: string | null | undefined;
  re: string;
  turn?: string | null | undefined;
  managerName?: string | null | undefined;
  phone?: string | null | undefined;
  phoneExtensionLine?: string | null | undefined;
  costCenter?: string | null | undefined;
  contactHour?: string | null | undefined;
  challengeLanguage?: string | null | undefined;
  productiveEquipament: boolean;
  productiveDescription?: string | null | undefined;
  areaResponsible?: string | null | undefined;
  areaExtensionLine?: string | null | undefined;
  email?: string | null | undefined;
  likes: number;
  financeValue: number;
  createdAt: any;
  updatedAt: any;
  motive?: string | null | undefined;
  father?: { challengeLanguage?: string | null | undefined } | null | undefined;
  sons?:
    | Array<{
        id: string;
        status: string;
        title: string;
        code?: string | null | undefined;
        description?: string | null | undefined;
        authorName: string;
        role?: string | null | undefined;
        re: string;
        turn?: string | null | undefined;
        managerName?: string | null | undefined;
        phone?: string | null | undefined;
        phoneExtensionLine?: string | null | undefined;
        costCenter?: string | null | undefined;
        contactHour?: string | null | undefined;
        productiveEquipament: boolean;
        productiveDescription?: string | null | undefined;
        areaResponsible?: string | null | undefined;
        areaExtensionLine?: string | null | undefined;
        email?: string | null | undefined;
        likes: number;
        financeValue: number;
        createdAt: any;
        updatedAt: any;
        motive?: string | null | undefined;
        expectations?:
          | Array<{
              expectation: string;
              expectationDescription: string;
              challengeLanguage?: string | null | undefined;
              id: string;
              isSelected: boolean;
            }>
          | null
          | undefined;
        unity?:
          | {
              id: string;
              name: string;
              country?:
                | { id: string; name: string; flag: string }
                | null
                | undefined;
            }
          | null
          | undefined;
        challenge?:
          | {
              id: string;
              title: string;
              name: string;
              description: string;
              createdAt: any;
              language: string;
              status: string;
            }
          | null
          | undefined;
        committee?:
          | {
              id: string;
              name: string;
              status: boolean;
              area?: { id: string; name: string } | null | undefined;
              manager?: { id: string; name: string } | null | undefined;
              participants?:
                | Array<{ id: string; name: string }>
                | null
                | undefined;
            }
          | null
          | undefined;
        authors?:
          | Array<{
              id: string;
              name: string;
              area?: string | null | undefined;
              cpf?: string | null | undefined;
              email?: string | null | undefined;
              jobRole?: string | null | undefined;
            }>
          | null
          | undefined;
      }>
    | null
    | undefined;
  expectations?:
    | Array<{
        id: string;
        expectation: string;
        expectationDescription: string;
        challengeLanguage?: string | null | undefined;
      }>
    | null
    | undefined;
  unity?:
    | {
        id: string;
        name: string;
        country?: { id: string; name: string; flag: string } | null | undefined;
      }
    | null
    | undefined;
  challenge?:
    | {
        id: string;
        title: string;
        name: string;
        description: string;
        createdAt: any;
        language: string;
        status: string;
      }
    | null
    | undefined;
  committee?:
    | {
        id: string;
        name: string;
        status: boolean;
        area?: { id: string; name: string } | null | undefined;
        manager?: { id: string; name: string } | null | undefined;
        participants?: Array<{ id: string; name: string }> | null | undefined;
      }
    | null
    | undefined;
  authors?:
    | Array<{
        id: string;
        name: string;
        area?: string | null | undefined;
        cpf?: string | null | undefined;
        email?: string | null | undefined;
        jobRole?: string | null | undefined;
      }>
    | null
    | undefined;
};

export type IdeaExpectationFragment = {
  id: string;
  expectation: string;
  expectationDescription: string;
  challengeLanguage?: string | null | undefined;
};

export type ChallengeFragment = {
  id: string;
  title: string;
  name: string;
  description: string;
  createdAt: any;
  language: string;
  status: string;
};

export type UnityFragment = {
  id: string;
  name: string;
  country?: { id: string; name: string; flag: string } | null | undefined;
};

export type CommitteeFragment = {
  id: string;
  name: string;
  status: boolean;
  area?: { id: string; name: string } | null | undefined;
  manager?: { id: string; name: string } | null | undefined;
  participants?: Array<{ id: string; name: string }> | null | undefined;
};

export type NewsFragment = {
  id: string;
  createdAt: any;
  updatedAt: any;
  title: string;
  description: string;
  content: string;
  author: string;
  status: string;
  imageUrl?: string | null | undefined;
  tags?: Array<{ id: string; tag: string }> | null | undefined;
};

export type AreaFragment = {
  id: string;
  name: string;
  committee?:
    | Array<{
        id: string;
        name: string;
        status: boolean;
        area?: { id: string; name: string } | null | undefined;
        manager?: { id: string; name: string } | null | undefined;
        participants?: Array<{ id: string; name: string }> | null | undefined;
      }>
    | null
    | undefined;
};

export type CountryFragment = { id: string; name: string; flag: string };

export type ActionFragment = {
  id: string;
  code: string;
  title: string;
  description: string;
  status: string;
  endDate: any;
  createdAt: any;
  updatedAt: any;
};

export type DefaultMessageFragment = { message: string; status: number };

export type KambanFragment = {
  name: string;
  cards?:
    | Array<{
        commentsCount: number;
        doneTasks: number;
        filesCount: number;
        totalTasks: number;
        action: {
          id: string;
          code: string;
          title: string;
          description: string;
          status: string;
          endDate: any;
          createdAt: any;
          updatedAt: any;
        };
      }>
    | null
    | undefined;
};

export type ActionKambanFragment = {
  commentsCount: number;
  doneTasks: number;
  filesCount: number;
  totalTasks: number;
  action: {
    id: string;
    code: string;
    title: string;
    description: string;
    status: string;
    endDate: any;
    createdAt: any;
    updatedAt: any;
  };
};

export type GetIdeasQueryVariables = Exact<{ [key: string]: never }>;

export type GetIdeasQuery = {
  getIdeas: Array<{
    id: string;
    status: string;
    title: string;
    code?: string | null | undefined;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    phoneExtensionLine?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    challengeLanguage?: string | null | undefined;
    productiveEquipament: boolean;
    productiveDescription?: string | null | undefined;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    likes: number;
    financeValue: number;
    createdAt: any;
    updatedAt: any;
    motive?: string | null | undefined;
    father?:
      | { challengeLanguage?: string | null | undefined }
      | null
      | undefined;
    sons?:
      | Array<{
          id: string;
          status: string;
          title: string;
          code?: string | null | undefined;
          description?: string | null | undefined;
          authorName: string;
          role?: string | null | undefined;
          re: string;
          turn?: string | null | undefined;
          managerName?: string | null | undefined;
          phone?: string | null | undefined;
          phoneExtensionLine?: string | null | undefined;
          costCenter?: string | null | undefined;
          contactHour?: string | null | undefined;
          productiveEquipament: boolean;
          productiveDescription?: string | null | undefined;
          areaResponsible?: string | null | undefined;
          areaExtensionLine?: string | null | undefined;
          email?: string | null | undefined;
          likes: number;
          financeValue: number;
          createdAt: any;
          updatedAt: any;
          motive?: string | null | undefined;
          expectations?:
            | Array<{
                expectation: string;
                expectationDescription: string;
                challengeLanguage?: string | null | undefined;
                id: string;
                isSelected: boolean;
              }>
            | null
            | undefined;
          unity?:
            | {
                id: string;
                name: string;
                country?:
                  | { id: string; name: string; flag: string }
                  | null
                  | undefined;
              }
            | null
            | undefined;
          challenge?:
            | {
                id: string;
                title: string;
                name: string;
                description: string;
                createdAt: any;
                language: string;
                status: string;
              }
            | null
            | undefined;
          committee?:
            | {
                id: string;
                name: string;
                status: boolean;
                area?: { id: string; name: string } | null | undefined;
                manager?: { id: string; name: string } | null | undefined;
                participants?:
                  | Array<{ id: string; name: string }>
                  | null
                  | undefined;
              }
            | null
            | undefined;
          authors?:
            | Array<{
                id: string;
                name: string;
                area?: string | null | undefined;
                cpf?: string | null | undefined;
                email?: string | null | undefined;
                jobRole?: string | null | undefined;
              }>
            | null
            | undefined;
        }>
      | null
      | undefined;
    expectations?:
      | Array<{
          id: string;
          expectation: string;
          expectationDescription: string;
          challengeLanguage?: string | null | undefined;
        }>
      | null
      | undefined;
    unity?:
      | {
          id: string;
          name: string;
          country?:
            | { id: string; name: string; flag: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    challenge?:
      | {
          id: string;
          title: string;
          name: string;
          description: string;
          createdAt: any;
          language: string;
          status: string;
        }
      | null
      | undefined;
    committee?:
      | {
          id: string;
          name: string;
          status: boolean;
          area?: { id: string; name: string } | null | undefined;
          manager?: { id: string; name: string } | null | undefined;
          participants?: Array<{ id: string; name: string }> | null | undefined;
        }
      | null
      | undefined;
    authors?:
      | Array<{
          id: string;
          name: string;
          area?: string | null | undefined;
          cpf?: string | null | undefined;
          email?: string | null | undefined;
          jobRole?: string | null | undefined;
        }>
      | null
      | undefined;
  }>;
};

export type GetAreasQueryVariables = Exact<{ [key: string]: never }>;

export type GetAreasQuery = {
  areas: Array<{
    id: string;
    name: string;
    committee?:
      | Array<{
          id: string;
          name: string;
          status: boolean;
          area?: { id: string; name: string } | null | undefined;
          manager?: { id: string; name: string } | null | undefined;
          participants?: Array<{ id: string; name: string }> | null | undefined;
        }>
      | null
      | undefined;
  }>;
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = { createUser: { id: string; name: string } };

export type GetChallengesQueryVariables = Exact<{ [key: string]: never }>;

export type GetChallengesQuery = {
  getChallenges: Array<{
    id: string;
    language: string;
    status: string;
    name: string;
    title: string;
    description: string;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null | undefined;
  }>;
};

export type GetChallengeQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetChallengeQuery = {
  getChallenge: {
    id: string;
    language: string;
    status: string;
    name: string;
    title: string;
    description: string;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null | undefined;
  };
};

export type GetChallengesByLanguageQueryVariables = Exact<{
  language: Scalars["String"];
}>;

export type GetChallengesByLanguageQuery = {
  getChallengesByLanguage: Array<{
    id: string;
    language: string;
    status: string;
    name: string;
    title: string;
    description: string;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null | undefined;
  }>;
};

export type GetCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountriesQuery = {
  getCountries: Array<{ id: string; name: string; flag: string }>;
};

export type GetUnitiesByCountryQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetUnitiesByCountryQuery = {
  getUnitiesByCountry: Array<{
    id: string;
    name: string;
    country?: { name: string } | null | undefined;
  }>;
};

export type CreateIdeaMutationVariables = Exact<{
  data: CreateIdeaInput;
}>;

export type CreateIdeaKaizenMutationVariables = Exact<{
  data: CreateIdeaKaizenInput;
}>;

export type CreateIdeaMutation = {
  createIdea: {
    id: string;
    title: string;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    productiveEquipament: boolean;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    createdAt: any;
    updatedAt: any;
    country?: { id: string; name: string } | null | undefined;
    authors?:
      | Array<{ id: string; name: string; re: string }>
      | null
      | undefined;
    unity?: { id: string; name: string } | null | undefined;
    challenge?: { id: string; name: string } | null | undefined;
  };
};
export type CreateIdeaKaizenMutation = {
  createIdeaKaizen: {
    id: string;
    userId?: string;
    employeeId?: string;
    title: string;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    productiveEquipament?: boolean;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    createdAt: any;
    updatedAt: any;
    country?: { id: string; name: string } | null | undefined;
    authors?:
      | Array<{ id: string; name: string; re: string }>
      | null
      | undefined;
    unity?: { id: string; name: string } | null | undefined;
    challenge?: { id: string; name: string } | null | undefined;
  };
};

export type GetIdeaQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetIdeaQuery = {
  getIdea: {
    id: string;
    status: string;
    title: string;
    code?: string | null | undefined;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    phoneExtensionLine?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    challengeLanguage?: string | null | undefined;
    productiveEquipament: boolean;
    productiveDescription?: string | null | undefined;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    likes: number;
    financeValue: number;
    createdAt: any;
    updatedAt: any;
    motive?: string | null | undefined;
    father?:
      | { challengeLanguage?: string | null | undefined }
      | null
      | undefined;
    sons?:
      | Array<{
          id: string;
          status: string;
          title: string;
          code?: string | null | undefined;
          description?: string | null | undefined;
          authorName: string;
          role?: string | null | undefined;
          re: string;
          turn?: string | null | undefined;
          managerName?: string | null | undefined;
          phone?: string | null | undefined;
          phoneExtensionLine?: string | null | undefined;
          costCenter?: string | null | undefined;
          contactHour?: string | null | undefined;
          productiveEquipament: boolean;
          productiveDescription?: string | null | undefined;
          areaResponsible?: string | null | undefined;
          areaExtensionLine?: string | null | undefined;
          email?: string | null | undefined;
          likes: number;
          financeValue: number;
          createdAt: any;
          updatedAt: any;
          motive?: string | null | undefined;
          expectations?:
            | Array<{
                expectation: string;
                expectationDescription: string;
                challengeLanguage?: string | null | undefined;
                id: string;
                isSelected: boolean;
              }>
            | null
            | undefined;
          unity?:
            | {
                id: string;
                name: string;
                country?:
                  | { id: string; name: string; flag: string }
                  | null
                  | undefined;
              }
            | null
            | undefined;
          challenge?:
            | {
                id: string;
                title: string;
                name: string;
                description: string;
                createdAt: any;
                language: string;
                status: string;
              }
            | null
            | undefined;
          committee?:
            | {
                id: string;
                name: string;
                status: boolean;
                area?: { id: string; name: string } | null | undefined;
                manager?: { id: string; name: string } | null | undefined;
                participants?:
                  | Array<{ id: string; name: string }>
                  | null
                  | undefined;
              }
            | null
            | undefined;
          authors?:
            | Array<{
                id: string;
                name: string;
                area?: string | null | undefined;
                cpf?: string | null | undefined;
                email?: string | null | undefined;
                jobRole?: string | null | undefined;
              }>
            | null
            | undefined;
        }>
      | null
      | undefined;
    expectations?:
      | Array<{
          id: string;
          expectation: string;
          expectationDescription: string;
          challengeLanguage?: string | null | undefined;
        }>
      | null
      | undefined;
    unity?:
      | {
          id: string;
          name: string;
          country?:
            | { id: string; name: string; flag: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    challenge?:
      | {
          id: string;
          title: string;
          name: string;
          description: string;
          createdAt: any;
          language: string;
          status: string;
        }
      | null
      | undefined;
    committee?:
      | {
          id: string;
          name: string;
          status: boolean;
          area?: { id: string; name: string } | null | undefined;
          manager?: { id: string; name: string } | null | undefined;
          participants?: Array<{ id: string; name: string }> | null | undefined;
        }
      | null
      | undefined;
    authors?:
      | Array<{
          id: string;
          name: string;
          area?: string | null | undefined;
          cpf?: string | null | undefined;
          email?: string | null | undefined;
          jobRole?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type GetIdeaKaizenQuery = {
  getIdeaKaizen: Array<{
    id: string;
    title: string;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    productiveEquipament?: boolean;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    createdAt: any;
    updatedAt: any;
    country?: { id: string; name: string } | null | undefined;
    authors?:
      | Array<{ id: string; name: string; re: string }>
      | null
      | undefined;
    unity?: { id: string; name: string } | null | undefined;
    challenge?: { id: string; name: string } | null | undefined;
  }>;
};

export type GetIdeasSearchQueryVariables = Exact<{
  input: SearchIdeaInput;
}>;

export type GetIdeasSearchQuery = {
  getIdeasSearch: Array<{
    id: string;
    title: string;
    description?: string | null | undefined;
    createdAt: any;
    status: string;
    challengeLanguage?: string | null | undefined;
    code?: string | null | undefined;
  }>;
};

export type GetAllIdeasQueryVariables = Exact<{
  keyword: Scalars["String"];
}>;

export type GetAllIdeasQuery = {
  getAllIdeas: Array<{
    id: string;
    status: string;
    title: string;
    code?: string | null | undefined;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    phoneExtensionLine?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    challengeLanguage?: string | null | undefined;
    productiveEquipament: boolean;
    productiveDescription?: string | null | undefined;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    likes: number;
    financeValue: number;
    createdAt: any;
    updatedAt: any;
    motive?: string | null | undefined;
    father?:
      | { challengeLanguage?: string | null | undefined }
      | null
      | undefined;
    sons?:
      | Array<{
          id: string;
          status: string;
          title: string;
          code?: string | null | undefined;
          description?: string | null | undefined;
          authorName: string;
          role?: string | null | undefined;
          re: string;
          turn?: string | null | undefined;
          managerName?: string | null | undefined;
          phone?: string | null | undefined;
          phoneExtensionLine?: string | null | undefined;
          costCenter?: string | null | undefined;
          contactHour?: string | null | undefined;
          productiveEquipament: boolean;
          productiveDescription?: string | null | undefined;
          areaResponsible?: string | null | undefined;
          areaExtensionLine?: string | null | undefined;
          email?: string | null | undefined;
          likes: number;
          financeValue: number;
          createdAt: any;
          updatedAt: any;
          motive?: string | null | undefined;
          expectations?:
            | Array<{
                expectation: string;
                expectationDescription: string;
                challengeLanguage?: string | null | undefined;
                id: string;
                isSelected: boolean;
              }>
            | null
            | undefined;
          unity?:
            | {
                id: string;
                name: string;
                country?:
                  | { id: string; name: string; flag: string }
                  | null
                  | undefined;
              }
            | null
            | undefined;
          challenge?:
            | {
                id: string;
                title: string;
                name: string;
                description: string;
                createdAt: any;
                language: string;
                status: string;
              }
            | null
            | undefined;
          committee?:
            | {
                id: string;
                name: string;
                status: boolean;
                area?: { id: string; name: string } | null | undefined;
                manager?: { id: string; name: string } | null | undefined;
                participants?:
                  | Array<{ id: string; name: string }>
                  | null
                  | undefined;
              }
            | null
            | undefined;
          authors?:
            | Array<{
                id: string;
                name: string;
                area?: string | null | undefined;
                cpf?: string | null | undefined;
                email?: string | null | undefined;
                jobRole?: string | null | undefined;
              }>
            | null
            | undefined;
        }>
      | null
      | undefined;
    expectations?:
      | Array<{
          id: string;
          expectation: string;
          expectationDescription: string;
          challengeLanguage?: string | null | undefined;
        }>
      | null
      | undefined;
    unity?:
      | {
          id: string;
          name: string;
          country?:
            | { id: string; name: string; flag: string }
            | null
            | undefined;
        }
      | null
      | undefined;
    challenge?:
      | {
          id: string;
          title: string;
          name: string;
          description: string;
          createdAt: any;
          language: string;
          status: string;
        }
      | null
      | undefined;
    committee?:
      | {
          id: string;
          name: string;
          status: boolean;
          area?: { id: string; name: string } | null | undefined;
          manager?: { id: string; name: string } | null | undefined;
          participants?: Array<{ id: string; name: string }> | null | undefined;
        }
      | null
      | undefined;
    authors?:
      | Array<{
          id: string;
          name: string;
          area?: string | null | undefined;
          cpf?: string | null | undefined;
          email?: string | null | undefined;
          jobRole?: string | null | undefined;
        }>
      | null
      | undefined;
  }>;
};
export type GetAllIdeasKaizenQuery = {
  getAllIdeas: Array<{
    id: string;
    title: string;
    description?: string | null | undefined;
    authorName: string;
    role?: string | null | undefined;
    re: string;
    turn?: string | null | undefined;
    managerName?: string | null | undefined;
    phone?: string | null | undefined;
    costCenter?: string | null | undefined;
    contactHour?: string | null | undefined;
    productiveEquipament?: boolean;
    areaResponsible?: string | null | undefined;
    areaExtensionLine?: string | null | undefined;
    email?: string | null | undefined;
    createdAt: any;
    updatedAt: any;
    country?: { id: string; name: string } | null | undefined;
    authors?:
      | Array<{ id: string; name: string; re: string }>
      | null
      | undefined;
    unity?: { id: string; name: string } | null | undefined;
    challenge?: { id: string; name: string } | null | undefined;
  }>;
};

export type CreateIdeaCommentMutationVariables = Exact<{
  data: CreateIdeaCommentInput;
  id: Scalars["String"];
}>;

export type CreateIdeaCommentMutation = {
  createIdeaComment: { id: string; name: string; message: string };
};

export type AddLikeMutationVariables = Exact<{
  id: Scalars["String"];
}>;

export type AddLikeMutation = { addLike: number };

export type GetNewsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNewsQuery = {
  getNews: Array<{
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    description: string;
    author: string;
    imageUrl?: string | null | undefined;
    status: string;
    tags?: Array<{ id: string; tag: string }> | null | undefined;
  }>;
};

export type GetNewQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetNewQuery = {
  getNew: {
    id: string;
    title: string;
    createdAt: any;
    updatedAt: any;
    author: string;
    imageUrl?: string | null | undefined;
    status: string;
    content: string;
    description: string;
    tags?: Array<{ id: string; tag: string }> | null | undefined;
  };
};

export type GetNewsSearchQueryVariables = Exact<{
  keyword: Scalars["String"];
  language?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
}>;

export type GetNewsSearchQuery = {
  getNewsSearch: {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPage: number;
    previouPage: boolean;
    nextPage: boolean;
    news: Array<{
      id: string;
      createdAt: any;
      updatedAt: any;
      language: string;
      title: string;
      description: string;
      author: string;
      status: string;
      imageUrl?: string | null | undefined;
      content: string;
      tags?: Array<{ id: string; tag: string }> | null | undefined;
    }>;
  };
};

export type GetDashboardHomeQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardHomeQuery = {
  getDashboardHome: {
    news: number;
    approves: number;
    finances: number;
    energy: number;
    machineValue: number;
    water: number;
    waste: number;
    manValue: number;
  };
};

export type GetUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersQuery = {
  getUsers: Array<{ id: string; name: string; email: string; role: string }>;
};

export type LoginMutationVariables = Exact<{
  code: Scalars["String"];
  redirectUri: Scalars["String"];
  email: Scalars["String"];
  application: Scalars["String"];
  re: Scalars["String"];
  access_token: Scalars["String"];
}>;

export type LoginMutation = {
  login: {
    token?: string;
    country?: string;
    user: {
      id: string;
      name: string;
      email: string;
      photo?: string | null | undefined;
      role: string;
    };
    kaizen?: boolean;
    requiresEmployee?: boolean;
    code: string;
    access_token: string;
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;
export type MeQuery = {
  me: {
    id: string;
    name: string;
    email: string;
    photo?: string | null | undefined;
    employee?: Employee;
  };
};

export const UserFragmentDoc = gql`
  fragment User on User {
    id
    name
    email
    photo
    employee {
      id
      re
    }
  }
`;
export const CountryFragmentDoc = gql`
  fragment Country on Country {
    id
    name
    flag
  }
`;
export const UnityFragmentDoc = gql`
  fragment Unity on Unity {
    id
    name
    country {
      ...Country
    }
  }
  ${CountryFragmentDoc}
`;
export const ChallengeFragmentDoc = gql`
  fragment Challenge on Challenge {
    id
    title
    name
    description
    createdAt
    language
    status
  }
`;
export const CommitteeFragmentDoc = gql`
  fragment Committee on Committee {
    id
    name
    status
    area {
      id
      name
    }
    manager {
      id
      name
    }
    participants {
      id
      name
    }
  }
`;
export const IdeaExpectationFragmentDoc = gql`
  fragment IdeaExpectation on IdeaExpectation {
    id
    expectation
    expectationDescription
    challengeLanguage
  }
`;

export const IdeaKaizenFragment = gql`
  fragment IdeaKaizen on IdeaKaizen {
    id
    authorName
    code
    re
    frame {
      name
    }
    title
    area
    status
  }
`;

export const IdeaFragmentDoc = gql`
  fragment Idea on Idea {
    id
    status
    title
    code
    description
    authorName
    role
    re
    turn
    managerName
    father {
      challengeLanguage
    }
    phone
    phoneExtensionLine
    costCenter
    contactHour
    challengeLanguage
    sons {
      id
      status
      title
      code
      description
      authorName
      role
      re
      turn
      managerName
      phone
      phoneExtensionLine
      costCenter
      contactHour
      productiveEquipament
      productiveDescription
      areaResponsible
      areaExtensionLine
      email
      likes
      financeValue
      createdAt
      motive
      expectations {
        expectation
        expectationDescription
        challengeLanguage
        id
        isSelected
      }
      unity {
        ...Unity
      }
      challenge {
        ...Challenge
      }
      committee {
        ...Committee
      }
      authors {
        id
        name
        area
        cpf
        email
        jobRole
      }
    }
    productiveDescription
    areaResponsible
    areaExtensionLine
    email
    likes
    financeValue
    createdAt
    motive
    expectations {
      ...IdeaExpectation
    }
    unity {
      ...Unity
    }
    challenge {
      ...Challenge
    }
    committee {
      ...Committee
    }
    authors {
      id
      name
      area
      cpf
      email
      jobRole
    }
  }
  ${UnityFragmentDoc}
  ${ChallengeFragmentDoc}
  ${CommitteeFragmentDoc}
  ${IdeaExpectationFragmentDoc}
`;
export const NewsFragmentDoc = gql`
  fragment News on News {
    id
    createdAt
    updatedAt
    title
    description
    content
    author
    status
    imageUrl
    tags {
      id
      tag
    }
  }
`;
export const AreaFragmentDoc = gql`
  fragment Area on Area {
    id
    name
    committee {
      ...Committee
    }
  }
  ${CommitteeFragmentDoc}
`;
export const DefaultMessageFragmentDoc = gql`
  fragment DefaultMessage on DefaultMessage {
    message
    status
  }
`;
export const ActionFragmentDoc = gql`
  fragment Action on Action {
    id
    code
    title
    description
    status
    endDate
    createdAt
    updatedAt
  }
`;
export const ActionKambanFragmentDoc = gql`
  fragment ActionKamban on ActionKamban {
    commentsCount
    doneTasks
    filesCount
    totalTasks
    action {
      ...Action
    }
  }
  ${ActionFragmentDoc}
`;
export const KambanFragmentDoc = gql`
  fragment Kamban on Kamban {
    name
    cards {
      ...ActionKamban
    }
  }
  ${ActionKambanFragmentDoc}
`;
export const GetIdeasDocument = gql`
  query GetIdeas {
    getIdeas {
      ...Idea
    }
  }
  ${IdeaFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeasGQL extends Apollo.Query<
  GetIdeasQuery,
  GetIdeasQueryVariables
> {
  document = GetIdeasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAreasDocument = gql`
  query GetAreas {
    areas {
      ...Area
    }
  }
  ${AreaFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetAreasGQL extends Apollo.Query<
  GetAreasQuery,
  GetAreasQueryVariables
> {
  document = GetAreasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(data: $input) {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateUserGQL extends Apollo.Mutation<
  CreateUserMutation,
  CreateUserMutationVariables
> {
  document = CreateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetChallengesDocument = gql`
  query GetChallenges {
    getChallenges {
      id
      language
      status
      name
      title
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetChallengesGQL extends Apollo.Query<
  GetChallengesQuery,
  GetChallengesQueryVariables
> {
  document = GetChallengesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetChallengeDocument = gql`
  query getChallenge($id: String!) {
    getChallenge(id: $id, language: "pt-BR") {
      id
      language
      status
      name
      title
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetChallengeGQL extends Apollo.Query<
  GetChallengeQuery,
  GetChallengeQueryVariables
> {
  document = GetChallengeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetChallengesByLanguageDocument = gql`
  query GetChallengesByLanguage($language: String!) {
    getChallengesByLanguage(language: $language) {
      id
      name
      type
      title
      status
      language
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetChallengesByLanguageGQL extends Apollo.Query<
  GetChallengesByLanguageQuery,
  GetChallengesByLanguageQueryVariables
> {
  document = GetChallengesByLanguageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCountriesDocument = gql`
  query GetCountries {
    getCountries {
      id
      name
      flag
    }
  }
`;

export type GetUnitiesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnitiesQuery = {
  getUnities: Array<{
    id: string;
    name: string;
    country?: { id: string; name: string; flag: string } | null;
  }>;
};

export const GetUnitiesDocument = gql`
  query GetUnities {
    getUnities {
      ...Unity
    }
  }
  ${UnityFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetUnitiesGQL extends Apollo.Query<
  GetUnitiesQuery,
  GetUnitiesQueryVariables
> {
  document = GetUnitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: "root",
})
export class GetCountriesGQL extends Apollo.Query<
  GetCountriesQuery,
  GetCountriesQueryVariables
> {
  document = GetCountriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUnitiesByCountryDocument = gql`
  query GetUnitiesByCountry($id: String!) {
    getUnitiesByCountry(id: $id) {
      id
      name
      country {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetUnitiesByCountryGQL extends Apollo.Query<
  GetUnitiesByCountryQuery,
  GetUnitiesByCountryQueryVariables
> {
  document = GetUnitiesByCountryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateIdeaDocument = gql`
  mutation CreateIdea($data: CreateIdeaInput!) {
    createIdea(data: $data) {
      id
      title
      description
      authorName
      role
      re
      turn
      managerName
      phone
      costCenter
      contactHour
      country {
        id
        name
      }
      productiveEquipament
      areaResponsible
      areaExtensionLine
      email
      createdAt
      authors {
        id
        name
        re
      }
      unity {
        id
        name
      }
      challenge {
        id
        name
      }
    }
  }
`;

export const CreateKaizenIdeaDocument = gql`
  mutation IdeaKaizen($data: CreateIdeaKaizenInput!) {
    createIdeaKaizen(data: $data) {
      id
      title
      authorName
      re
      createdAt
    }
  }
`;
export const CreateAwardsDocument = gql`
  mutation CreateAwards($data: CreateAwardsInput!) {
    createAwards(data: $data) {
      id
      name
      value
      quantity
    }
  }
`;

export const BuyAwardsDocument = gql`
  mutation BuyAwards($data: BuyAwardsInput!) {
    buyAwards(data: $data) {
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateIdeaGQL extends Apollo.Mutation<
  CreateIdeaMutation,
  CreateIdeaMutationVariables
> {
  document = CreateIdeaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
@Injectable({
  providedIn: "root",
})
export class CreateKaizenIdeaGQL extends Apollo.Mutation<
  CreateIdeaKaizenMutation,
  CreateIdeaKaizenMutationVariables
> {
  document = CreateKaizenIdeaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetIdeaDocument = gql`
  query GetIdea($id: String!) {
    getIdea(id: $id) {
      ...Idea
    }
  }
  ${IdeaFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeaGQL extends Apollo.Query<
  GetIdeaQuery,
  GetIdeaQueryVariables
> {
  document = GetIdeaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetIdeaKaizenDocument = gql`
  query GetIdeaKaizen($id: String!) {
    getIdeaKaizen(id: $id) {
      ...Idea
    }
  }
  ${IdeaKaizenFragment}
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeaKaizenGQL extends Apollo.Query<
  GetIdeaKaizenQuery,
  GetIdeaQueryVariables
> {
  document = GetIdeaKaizenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetIdeasSearchDocument = gql`
  query GetIdeasSearch($input: SearchIdeaInput!) {
    getIdeasSearch(data: $input) {
      id
      title
      description
      createdAt
      status
      challengeLanguage
      code
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeasSearchGQL extends Apollo.Query<
  GetIdeasSearchQuery,
  GetIdeasSearchQueryVariables
> {
  document = GetIdeasSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAllIdeasDocument = gql`
  query GetAllIdeas($keyword: String!) {
    getAllIdeas(keyword: $keyword) {
      ...Idea
    }
  }
  ${IdeaFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetAllIdeasGQL extends Apollo.Query<
  GetAllIdeasQuery,
  GetAllIdeasQueryVariables
> {
  document = GetAllIdeasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetAllIdeasKaizenDocument = gql`
  query GetAllIdeas($keyword: String!) {
    getAllIdeaKaizen(keyword: $keyword) {
      ...Idea
    }
  }
  ${IdeaFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetAllIdeasKaizenGQL extends Apollo.Query<
  GetAllIdeasKaizenQuery,
  GetAllIdeasQueryVariables
> {
  document = GetAllIdeasKaizenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const CreateIdeaCommentDocument = gql`
  mutation CreateIdeaComment($data: CreateIdeaCommentInput!, $id: String!) {
    createIdeaComment(data: $data, id: $id) {
      id
      name
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateIdeaCommentGQL extends Apollo.Mutation<
  CreateIdeaCommentMutation,
  CreateIdeaCommentMutationVariables
> {
  document = CreateIdeaCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddLikeDocument = gql`
  mutation AddLike($id: String!) {
    addLike(id: $id)
  }
`;

@Injectable({
  providedIn: "root",
})
export class AddLikeGQL extends Apollo.Mutation<
  AddLikeMutation,
  AddLikeMutationVariables
> {
  document = AddLikeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNewsDocument = gql`
  query GetNews {
    getNews {
      id
      createdAt
      updatedAt
      title
      description
      author
      imageUrl
      tags {
        id
        tag
      }
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetNewsGQL extends Apollo.Query<
  GetNewsQuery,
  GetNewsQueryVariables
> {
  document = GetNewsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNewDocument = gql`
  query GetNew($id: String!) {
    getNew(id: $id) {
      id
      title
      createdAt
      updatedAt
      author
      imageUrl
      status
      content
      description
      tags {
        id
        tag
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetNewGQL extends Apollo.Query<GetNewQuery, GetNewQueryVariables> {
  document = GetNewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNewsSearchDocument = gql`
  query GetNewsSearch($keyword: String!, $language: String, $status: String) {
    getNewsSearch(keyword: $keyword, language: $language, status: $status) {
      totalCount
      pageSize
      currentPage
      totalPage
      previouPage
      nextPage
      news {
        id
        createdAt
        updatedAt
        language
        title
        description
        author
        status
        imageUrl
        tags {
          id
          tag
        }
        content
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetNewsSearchGQL extends Apollo.Query<
  GetNewsSearchQuery,
  GetNewsSearchQueryVariables
> {
  document = GetNewsSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDashboardHomeDocument = gql`
  query GetDashboardHome {
    getDashboardHome {
      news
      approves
      finances
      energy
      machineValue
      water
      waste
      manValue
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetDashboardHomeGQL extends Apollo.Query<
  GetDashboardHomeQuery,
  GetDashboardHomeQueryVariables
> {
  document = GetDashboardHomeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUsersDocument = gql`
  query GetUsers {
    getUsers {
      id
      name
      email
      role
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetUsersGQL extends Apollo.Query<
  GetUsersQuery,
  GetUsersQueryVariables
> {
  document = GetUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginDocument = gql`
  mutation Login(
    $code: String!
    $redirectUri: String!
    $email: String!
    $application: String!
    $re: String!
    $access_token: String!
  ) {
    login(
      data: {
        application: $application
        code: $code
        redirectUri: $redirectUri
        email: $email
        re: $re
        access_token: $access_token
      }
    ) {
      user {
        ...User
        role
      }
      token
      country
      kaizen
      requiresEmployee
      access_token
    }
  }
  ${UserFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class LoginGQL extends Apollo.Mutation<
  LoginMutation,
  LoginMutationVariables
> {
  document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MeDocument = gql`
  query Me {
    me {
      ...User
    }
  }
  ${UserFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
  document = MeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
